// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"styles_modalBody__66xfd","modalOverlay":"styles_modalOverlay__1U8t1"};